import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {NotificationsService} from "angular2-notifications";
import {UserService} from "../services/user.service";
import {ReportService} from "../services/report.service";
import {PagerserviceService} from "../services/pagerservice.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {ExchangeService} from "../services/exchange.service";
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-admintradereport',
  templateUrl: './admintradereport.component.html',
  styleUrls: ['./admintradereport.component.css']
})
export class AdmintradereportComponent implements OnInit {
  searchObj = {
    search: '',
    time1: new Date(),
    time: new Date(),
    perpage:0,
    page:0,
    _csrf:''
}
settings = {
  bigBanner: true,
  format: 'dd-MMM-yyyy',
  defaultOpen: false,
  timePicker: true,
  closeOnSelect: true,
}
orderslist = [];
Tpager: number;
totalRecord =0;
orderslistFlag = false;
pager1: any = {};
pager: number;
FilPerpage: number;
FilPage:number;
exportorderslist=[];
fileName: string;
currentPag:any = 0;
public currentCurrency:any = 'EUR';
  constructor(private userService: UserService,
              private router: Router,
              private notif: NotificationsService,
              private pagerService: PagerserviceService,
              private reportService: ReportService,
              private exchangeService: ExchangeService,
              private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    if (!this.userService.isLoggedIn()) {
      this.router.navigateByUrl('/index');
  }else {
    var d = new Date();
            this.searchObj.time=new Date(d.setDate(d.getDate()));
            this.FilPage = 1;
            this.FilPerpage = 10;
            this.csrf();
            this.exchangeService.CompleteOrderEvent.subscribe(price => {
              // this.getAdminReports();
          })
  }
  }
  csrf() {
    this.userService.csrf().subscribe((success) => {
      this.searchObj._csrf = success._csrf;
      // this.getAdminReports();
  }, (error) => {
      if(error.status>0) {
          this.notif.error(
              'CSRF',
              error.error.message,
              {
                  timeOut: 5000,
                  showProgressBar: true,
                  pauseOnHover: true,
                  clickToClose: true,
                  maxLength: 50
              }
          )
      }
  })
  }
  round(value){
   return  parseFloat(value).toFixed(2)
  }
  // getAdminReports(){
  //   if(new Date(this.searchObj.time).setHours(0,0,0,0)>new Date(this.searchObj.time1).setHours(0,0,0,0))
  //   {
  //     this.notif.error(
  //       'Alert',
  //       "from date should less than to date",
  //       {
  //         timeOut         : 5000,
  //         showProgressBar : true,
  //         pauseOnHover    : true,
  //         clickToClose    : true,
  //         maxLength       : 50
  //       }
  //     )
  //     return false;
  //   }
  //   this.spinnerService.show();
  //   this.searchObj.perpage = this.FilPerpage;
  //   this.searchObj.page = this.FilPage;
  //   this.reportService.getAdminsTradeReport(this.searchObj).subscribe((success) => {
  //     this.orderslist = [];
  //     this.spinnerService.hide();
  //     if(success.transactions.trade == undefined || success.transactions.trade == null){
            
  //     }
  //     else{
  //         this.orderslist = success.transactions.trade;
  //         this.Tpager = success.pages;
  //         this.totalRecord = success.total;
  //         this.currentPag = success.current;
  //         this.setPage(this.FilPage);
  //         this.orderslistFlag = true;
  //         this.exportorderslist = [];
  //     }
  //   }, (error) => {
  //     this.spinnerService.hide();
  //     this.notif.error(
  //         'Order List',
  //         error.error.message,
  //         {
  //             timeOut: 5000,
  //             showProgressBar: true,
  //             pauseOnHover: true,
  //             clickToClose: true,
  //             maxLength: 50
  //         }
  //     )
  // })
  // }
  setPage(page: number) {
    // get pager object from service
    this.pager1 = this.pagerService.getPager(this.Tpager, page);
}
setPageOnClick(page:number){
  this.pager = page;
  this.FilPage =this.pager;
  // this.getAdminReports();
}
/**
 * 
 * @param trade report 
 */
// exportExcel(trade:string){
//     this.reportService.getAdminsTradeexport(this.searchObj).subscribe((success) => {
//       this.spinnerService.hide();
//       if(success.transactions.trade == undefined || success.transactions.trade == null){
            
//       }
//       else{
//         this.exportorderslist = [];
//         var orderslist = success.transactions.trade;
//         var convertionrate = 0;
//         var totalamount= 0;
//         for(let i = 0; i<orderslist.length; i++){
//           if(this.currentCurrency=='EUR'){
//             totalamount = orderslist[i].totalamount.toFixed(2) * orderslist[i].eur_conversion;
//             convertionrate =  orderslist[i].eur_conversion;
//         }else if (this.currentCurrency=='INR'){
//             totalamount = orderslist[i].totalamount.toFixed(2) * orderslist[i].inr_conversion;
//             convertionrate =  orderslist[i].inr_conversion;
//         }else if(this.currentCurrency=='USD'){
//             totalamount = orderslist[i].totalamount.toFixed(2) * orderslist[i].usd_conversion;
//             convertionrate =  orderslist[i].usd_conversion;
//         }else{}
//             this.exportorderslist.push({
//               'Split Timestamp (UTC +0000)'         : orderslist[i].createdAt,
//               'FIFO timestamp (UTC +0000)'         : orderslist[i].posTimestamp,
//               'Business Name'                       : "Blockoville",
//               'Trade Id'                            : orderslist[i].tradeid,
//               'Split Id'                            : orderslist[i].splitid,
//               'Admin order id '                     : orderslist[i].uniqorderId,
//               'Admin User Id'                       : (orderslist[i].manual==1)?"AMU"+orderslist[i].admin.userid:"ASU"+orderslist[i].admin.userid,
//               'Admin User Name'                     : (orderslist[i].manual==1)?orderslist[i].admin.name:"AdminSystemUser",
//               'Pair'                                : orderslist[i].pair,
//               'Type'                                : orderslist[i].buysell,
//               'AdminTraded price'                   : orderslist[i].price,
//               'Admin trade qty'                     : orderslist[i].amount.toFixed(5),
//               'Admin MV local (excl. fees)'         : orderslist[i].totalamount.toFixed(2),
//               'Convertion rate'                     : convertionrate,
//               'Admin MV EUR (excl. fees)'           : totalamount,
//               'Trading Venue'                       : orderslist[i].tradingvenue,
//               'Trading Venue Trade ID'              : orderslist[i].tradingvenuetradeid,
//               'Trading venue price'                 : orderslist[i].tradingvenueprice,
//               'Trading venue qty'                   : orderslist[i].tradingvenuequantity,
//               'Trading venue MV EUR (excl. fees)'   : this.round((orderslist[i].tradingvenuequantity)*(orderslist[i].tradingvenueprice)),
//               'Trading venue MV local (excl. fees)' : this.round((orderslist[i].tradingvenuequantity)*(orderslist[i].tradingvenueprice)),
//               'Admin Net P&L (excl. Fees)'          : orderslist[i].profitloss,
//               'Trading venue time stamp'            : (orderslist[i].splitid!='')?(orderslist[i].tradingvenuetime):'',
//           })
//           }
//           this.fileName = 'AdminTradeReport.xlsx'
//           const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.exportorderslist);
//               /* generate workbook and add the worksheet */
//               const wb: XLSX.WorkBook = XLSX.utils.book_new();
//               XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
//               /* save to file */
//               XLSX.writeFile(wb, this.fileName);
//       }
// });
// }
ChangeCurrency(event){
  this.currentCurrency = event.target.value
}
}



// WEBPACK FOOTER //
// ./src/app/admintradereport/admintradereport.component.ts